import axios from 'axios';

export class Auth{

    static create(){
        return {
            username: null,
            password: null
        };
    }

    /**
     *
     * @param json
     * @return {Promise}
     */
    static async login(json){
        return new Promise((resolve, reject) => {
            axios.post('login', json, {
                timeout: 8000
            })
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    static async remember(json){
        return new Promise((resolve, reject) => {
            axios.post('/api/v1/remember-password', json, {
                timeout: 10000
            })
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static async isAuth(){
        return new Promise((resolve, reject) => {
            axios.get('api/v1/is-auth', {
                timeout: 5000
            })
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    static async me(){
        return new Promise((resolve, reject) => {
            axios.get('api/v1/me', {
                timeout: 5000
            })
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }



    /**
     *
     * @param json
     * @return {Promise}
     */
    static updatePassword(json){
        return new Promise((resolve, reject) => {
            axios.post('update-password', json, {
                timeout: 5000
            })
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

}
